import { defineStore } from 'pinia';
import { computed, ref, watch } from 'vue';
import { useSessionStore } from './session';
import { AssessmentQuestion } from '../types/assessment';
import { Session } from '../types/session';
import { useClassStore } from './class';
import { useUserStore } from './user';
import { SignalRRoom } from '../types/signalr';
import { UserRole } from '../types/user';

export const useLectureStore = defineStore('lecture', () => {
    const user = useUserStore()
    const session = useSessionStore()
    const classStore = useClassStore()
    const studentViewAnswer = ref<boolean>(true)
    const questions = computed<AssessmentQuestion[]>(() => session.classContent?.[Session.lecture].questions || [])
    const currentQuestionIndex = ref<number>(0)
    const currentQuestion = computed<AssessmentQuestion | null>(() => questions.value[currentQuestionIndex.value] || null)
    const isFinished = computed<boolean>(() => {
        if (!questions.value.length) return false;

        // check if student answered all the question
        return questions.value.every(lectureQuestion => {
            return classStore.currentStudent?.lectureQuestions?.some(studentQuestion => {
                // check if student selected all possible answers
                // return studentQuestion.id === lectureQuestion.id && studentQuestion.answer.filter(answer => answer.answer.length).length >= lectureQuestion.totalCorrectAnswer
                // check if student selected at least one answer
                return studentQuestion.id === lectureQuestion.id && studentQuestion.answer.filter(answer => answer.answer.length).length
            })
        })
    })
    const isSubmitting = ref<boolean>(false)
    const isTeacherSubmitted = ref<boolean>(false)
    const isSubmitted = computed<boolean>(() => {
        if (user.userRole === UserRole.student) {
            return classStore.currentStudent?.isSubmitLecture || false
        }
        return isTeacherSubmitted.value
    })

    function syncLecture(room: SignalRRoom) {
        studentViewAnswer.value = !!room.lecture.showCorrectAnswer
    }

    watch(() => classStore.selectedClassDetails?.id, () => {
        isSubmitting.value = false
    })

    return {
        studentViewAnswer,
        questions,
        currentQuestionIndex,
        currentQuestion,
        isFinished,
        isSubmitting,
        isTeacherSubmitted,
        isSubmitted,
        syncLecture
    }
}, {
    persist: {
        pick: ['currentQuestionIndex']
    }
})